import { Header } from '@components/Header';
import { routes } from '@routes';
import { Helmet } from 'react-helmet-async';
import { useLocation, useSearchParams } from 'react-router-dom';

import { getOnboardingVideoHost } from '../helpers/getOnboardingVideoHost';
import { isAllowedOnboardingVideoSrc } from '../helpers/isAllowedOnboardingVideoSrc';
import { TrainingLessonPlayer } from './components/TrainingLessonPlayer';

type TWatchLocationState = {
  from?: string;
};

export const TrainingWatchPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const src = searchParams.get('src') ?? '';
  const videoHost = getOnboardingVideoHost();
  const isAllowed = isAllowedOnboardingVideoSrc(src, videoHost);
  const from = (location.state as TWatchLocationState | null)?.from;

  return (
    <>
      <Helmet>
        <title>Watch Training - AutoScript</title>
      </Helmet>
      <Header title="Watch Training" backRoute={from || routes.training.make()} />

      <main className="px-4 md:px-[30px] pt-2 pb-[70px]">
        {!isAllowed ? (
          <p className="text-sm text-[var(--color-text-muted)]">This training lesson link is invalid or not allowed.</p>
        ) : (
          <TrainingLessonPlayer src={src} />
        )}
      </main>
    </>
  );
};
